import React, { memo, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';

const colors = new Colors();

const PlaneMacro = memo(({diameter, isShowing, startDragging, isSelected, macro, coordinates}) => {
    // center
    let {x,y} = coordinates;

    let fill = colors.getColorForHash(macro.id);
    let radius = Math.max(12, diameter / 6);
    let className = "macro";
    if (isSelected) {
        className += " selected";
    }
    if (isShowing) {
        className += " showing";
    }
    return (
        <g>
          <circle
            className={className}
            onMouseDown={(e) => startDragging(e, macro)}
            cx={x}
            cy={y}
            r={radius}
            fill={fill}
            stroke={fill}
          />
          <text
            onMouseDown={(e) => startDragging(e, macro)}
            x={x - 3} y={y + 5} className={isSelected ? "selected macro-text" : "macro-text"}>{macro.number}</text>
        </g>
    );
});

export default PlaneMacro;
